import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import RequireRoles from "../../auth/RequireRoles";
import { creatorRoles } from "../../auth/authUtils";

import ModuleBrowser from "./browse/ModuleBrowser";
import ModuleEdit from "./edit/ModuleEdit";

const ModuleAdminView = () => {
  const navigate = useNavigate();

  const handleCancel = () => navigate(-1);
  return (
    <Routes>
      <Route
        index
        element={
          <RequireRoles roles={["ROLE_ADMIN"]} showUnauthorized={false}>
            <ModuleBrowser view="admin" />
          </RequireRoles>
        }
      />
      <Route
        path=":id/*"
        element={
          <RequireRoles roles={creatorRoles} showUnauthorized={false}>
            <ModuleEdit view="admin" onCancel={handleCancel} />
          </RequireRoles>
        }
      />
    </Routes>
  );
};

export default ModuleAdminView;
